<template>
  <main >
    <router-view/>
  </main>
</template>

<script>
import '@/assets/css/base.css';
import '@/assets/css/main.css';



export default {
  name: 'App',
  components: {
  }
}
</script>

<style></style>
